import { render, staticRenderFns } from "./App.vue?vue&type=template&id=133677a0&"
import script from "./App.vue?vue&type=script&lang=ts&"
export * from "./App.vue?vue&type=script&lang=ts&"
import style0 from "./App.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.9.0_babel-core@7.0.0-bridge.0_@babel+core@7.8.4_supports-color@6.1.0___ca_954b896a4cbf29da1b205b1ff899e628/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/.pnpm/vuetify-loader@1.4.3_vue-template-compiler@2.6.11_vuetify@2.6.1_vue@2.6.11__webpack@4.41.6_supports-color@6.1.0_/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VAppBar,VAppBarNavIcon,VFadeTransition,VMain})
